import React from "react";
import __ from "src/utils/Translations";

export const getAreaImportInstructions = (): React.ReactNode[] => [
  <>
    {__("Pierwszy wiersz pełni funkcję")} <strong>{__("nagłówka")}</strong>
    {__(", a import danych rozpoczyna się od")}{" "}
    <strong>{__("drugiego wiersza")}</strong>
    {__(". Zawartość pierwszego")}{" "}
    <strong>{__("wiersza nie jest przetwarzana")}</strong>.
  </>,
  <>
    {__("Każdy wiersz w pliku powinien zawierać dokładnie")}{" "}
    <strong>{__("7 kolumn")}</strong>
    {__(". Wypełniasz tylko te pola, które chcesz")}{" "}
    <strong>{__("zaktualizować")}</strong>
    {__(" - pozostałe możesz zostawić")} <strong>{__("puste")}</strong>.
  </>,
  <>
    {__("Jeśli chcesz wyczyścić dane w danym polu, wpisz")}{" "}
    <strong>{__("„NULL”")}</strong>
    {". "}
    {__("To pozwoli")} <strong>{__("usunąć istniejącą wartość")}</strong>
    {". "}
  </>,
  <>
    {__("Możesz skorzystać z gotowego")}{" "}
    <strong>{__("szablonu z nazwami kolumn")}</strong>{" "}
    {__("lub wyeksportować plik z")}{" "}
    <strong>{__("aktualnymi obszarami")}</strong>
    {", "}
    {__("jeśli chcesz edytować je zbiorczo.")}
  </>,
  <>
    {__("Oczekiwany format plików to")}{" "}
    <strong>{__("CSV UTF-8 rozdzielany średnikami")}</strong>
  </>,
];

export const getAreaUpdateFields = (): string[] => [
  __("Nazwa obszaru"),
  __("Osoba zarządzająca"),
  __("Numer FK osoby zarządzającej"),
  __("Czy osoba zarządzająca będzie członkiem tego obszaru"),
  __("Nadrzędny obszar"),
  __("Wyświetlany dodatkowy obszar"),
  __("Opis obszaru"),
];
